<template>
  <v-container>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card inline icon="mdi-clipboard-check" color="primary" class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-form class="pt-5">
          <parametros ref="validacoesParametros" :items="validacao" />
          <v-row>
            <v-col />
            <v-col cols="12" md="6">
              <v-btn
                id="btn-save-validacao"
                color="success"
                min-width="100"
                style="float: right"
                class="mr-0 mt-5"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import ValidadorContabilService from '@/services/ValidadorContabilService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Parametros: () => import('@/components/validadorContabil/Parametros')
    },
    mixins: [tourMixins],

    data: () => ({
      loading: false,
      arrTour: [
        {
          element: '#titulo-validacao-contabil',
          intro: 'Aqui você deverá inserir um nome para sua Validação Contábil.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#select-teste-validacao-contabil',
          intro: 'Aqui você pode selecionar os testes que sua Validação Contábil deve executar.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#btn-save-validacao',
          intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua Validação Contábil.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      validacao: {}
    }),

    computed: {
      title() {
        return this.$route.params.id ? `Editando Validação` : 'Adicionar Nova Validação';
      }
    },

    mounted() {
      if (this.$route.params.id) {
        this.getValidacao(this.$route.params.id);
      }
      this.iniciarTourPagina();
    },

    methods: {
      getValidacao(id) {
        ValidadorContabilService.getValidacao(id)
          .then((response) => {
            this.validacao = response.data.data;
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar validação.', '', { position: 'topRight' });
            this.$router.push({ name: 'Validador Contábil Historico' });
          });
      },
      salvar() {
        const data = this.$refs.validacoesParametros.exportData();
        data.id = this.$route.params.id;
        this.loading = true;

        ValidadorContabilService.salvar(data)
          .then(() => {
            this.$toast.success('Validação salva com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Validador Contábil Historico' });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar validação.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>
